import script from "./GeneticIdInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneticIdInput.vue?vue&type=script&setup=true&lang=ts"

import "./GeneticIdInput.vue?vue&type=style&index=0&id=15650d6c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src839921157/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15650d6c"]])

export default __exports__